import '../../libs/dhtmlxgantt/windowNavigatorPolyfill';
import log from '$$log';
import GanttAdapter from '$$store/adapters/gantt';
import { Gantt } from '../../libs/dhtmlxgantt/dhtmlxgantt';
import AutoSchedulePatches from './autoScheduling';
import Baselines from './baselines';
import Chart from './chart/main';
import { manualParentTaskBarLayersPatch } from './extensions/manualParentTaskBarLayersPatch';
import Config from './config';
import Controllers from './controllers';
import Events from './events';
import Extensions from './extensions';
import GanttDataApi from './ganttDataApi';
import Grid from './grid';
import ganttPreloader from './helpers/preloader';
import Workload from './workload';
import WorkloadLayout from './workload/layout';

// This file provide methods to init gantt instance for different app modes
export default {
  instance: null,

  async initGanttInstanceMultiView(multiviewId) {
    const timer = log.time('initGanttInstanceMultiView');

    this.destroyPreviousInstance();

    const tCreate = log.time('initGanttInstanceMultiView.createInstance');
    const instance = this.createInstance(multiviewId, true);
    tCreate.end();

    this.instance = instance;

    const getDataTimer = log.time('initGanttInstanceMultiView.getTasksData');
    const ganttIds = this.instance.ganttDataApi.getMultiviewItem(multiviewId).ganttIDs;
    const tasksData = this.instance.ganttDataApi.getTasksForMultiView(ganttIds);
    const projectConfig = this.instance.ganttDataApi.getActiveProjectConfig();

    getDataTimer.end();

    this.configureInstance(instance, ganttIds, projectConfig, true);

    this.renderInstance(instance, tasksData);

    // for(const ganttId of ganttIds) {
    //   await instance.ganttDataApi.correctDatesByProjectCalendar(ganttId);
    // }

    window.gantt2 = instance;

    timer.end();

    return instance;
  },

  initGanttInstance(ganttId) {
    const timer = log.time('initGanttInstance');

    this.destroyPreviousInstance(); // need destroy previous instance to avoid memory leaks

    const instance = this.createInstance(ganttId);
    this.instance = instance;

    const getDataTimer = log.time('initGanttInstance.getTasksData');
    const tasksData = this.instance.ganttDataApi.getTasksForGantt(ganttId);
    const projectConfig = this.instance.ganttDataApi.getActiveProjectConfig();

    getDataTimer.end();

    if (this.instance.config.isArchived) {
      this.configureInstanceArchived(instance, ganttId, projectConfig);
    } else {
      this.configureInstance(instance, ganttId, projectConfig);
    }

    this.renderInstance(instance, tasksData);

    const correctDatesTimer = log.time('initGanttInstance.correctDates');

    instance.ganttDataApi.correctDatesByProjectCalendar(ganttId);
    correctDatesTimer.end();

    window.gantt2 = instance;

    timer.end();

    return instance;
  },

  initGanttInstanceExport(ganttId) {
    const timer = log.time('initGanttInstanceExport');

    this.destroyPreviousInstance();

    const tCreate = log.time('initGanttInstanceExport.createInstance');
    const instance = this.createInstance(ganttId);
    tCreate.end();

    this.instance = instance;

    const getDataTimer = log.time('initGanttInstanceExport.getTasksData');
    const tasksData = this.instance.ganttDataApi.getTasksForGantt(ganttId);
    const projectConfig = this.instance.ganttDataApi.getActiveProjectConfig();

    getDataTimer.end();

    this.configureInstanceForExport(instance, ganttId, projectConfig);

    this.renderInstance(instance, tasksData);

    // window.gantt2 = instance;

    timer.end();

    return instance;
  },

  initGanttInstanceHistory(ganttId, ganttData) {
    const timer = log.time('initGanttInstanceHistory');

    this.destroyPreviousInstance();

    const tCreate = log.time('initGanttInstanceHistory.createInstance');
    const instance = this.createInstance(ganttId, false, ganttData);
    tCreate.end();

    this.instance = instance;

    const getDataTimer = log.time('initGanttInstanceHistory.getTasksData');
    const tasksData = this.instance.ganttDataApi.getTasksForGantt(ganttId);
    const projectConfig = this.instance.ganttDataApi.getActiveProjectConfig();

    getDataTimer.end();

    this.configureInstanceForHistory(instance, ganttId, projectConfig);

    this.renderInstance(instance, tasksData);

    // window.gantt2 = instance;

    timer.end();

    return instance;
  },

  initGanttInstanceExportMultiview(multiviewId) {
    const timer = log.time('initGanttInstanceExportMultiview');

    this.destroyPreviousInstance();

    const tCreate = log.time('initGanttInstanceExportMultiview.createInstance');
    const instance = this.createInstance(multiviewId, true);
    tCreate.end();

    this.instance = instance;

    const getDataTimer = log.time('initGanttInstanceExportMultiview.getTasksData');
    const ganttIds = this.instance.ganttDataApi.getMultiviewItem(multiviewId).ganttIDs;
    const tasksData = this.instance.ganttDataApi.getTasksForMultiView(ganttIds);
    const projectConfig = this.instance.ganttDataApi.getActiveProjectConfig();

    getDataTimer.end();

    this.configureInstanceForExport(instance, ganttIds, projectConfig);

    this.renderInstance(instance, tasksData);

    // window.gantt2 = instance;

    timer.end();

    return instance;
  },

  initGanttInstanceWorkload(ganttIds) {
    const timer = log.time('initGanttInstanceWorkload');

    this.destroyPreviousInstance();

    const tCreate = log.time('initGanttInstanceWorkload.createInstance');
    const instance = Gantt.getGanttInstance();

    GanttDataApi.init(instance, null);

    this.instance = instance;
    window.gantt2 = instance;

    this.instance.config.isWorkload = true;
    tCreate.end();

    const getDataTimer = log.time('initGanttInstanceWorkload.getTasksData');
    const tasksData = this.instance.ganttDataApi.getTasksForMultiView(ganttIds);
    const projectConfig = this.instance.ganttDataApi.getActiveProjectConfig();

    getDataTimer.end();

    this.configureInstance(instance, ganttIds, projectConfig, true);

    this.renderInstance(instance, tasksData, true);

    // AutoSchedulePatches.init(instance);
    // Controllers.init(instance);
    // Config.initBaseLayout(instance);
    // Extensions.init(instance);
    // // Chart.init(instance);
    // Events.init(instance);
    // GanttAdapter.init(instance);

    // this.renderInstance(instance, tasksData);

    // this.instance.$ui.getView('ganttChart').hide();
    // this.instance.$ui.getView('workload').resize();

    timer.end();
  },

  destroyPreviousInstance() {
    if (!this.instance || this.instance.$destroyed) return;
    const timer = log.time('ganttDestroy');

    GanttAdapter.destruct();
    this.instance.destructor();
    timer.end();
  },

  createInstance(id, isMultiview = false, ganttData = null) {
    const instance = Gantt.getGanttInstance();

    GanttDataApi.init(instance, ganttData);

    instance.config[isMultiview ? 'multiview_id' : 'gantt_id'] = id;
    if (isMultiview) {
      instance.config.multiview = true;
    } else {
      const projectData = instance.ganttDataApi.getProjectItem(id);

      if (projectData.is_archived) instance.config.isArchived = true;
    }

    return instance;
  },

  configureInstance(instance, id, projectConfig, isMultiview = false) {
    // Order is important
    const tConfigure = log.time('ganttConfigure');

    AutoSchedulePatches.init(instance);

    const tControllers = log.time('ganttConfigure.controllers');
    Controllers.init(instance); // Controller should be initialized before Config because we use them in Config
    tControllers.end();

    const tConfig = log.time('ganttConfigure.config');
    Config.init(id, instance, projectConfig); // Set gantt.config, plugins, calendars and etc.
    tConfig.end();

    const tExtensions = log.time('ganttConfigure.extensions');
    Extensions.init(instance); // This module adds additional (sometimes override) functionality to gantt instance
    tExtensions.end();

    const tGrid = log.time('ganttConfigure.grid');
    Grid.init(instance, projectConfig);
    tGrid.end();

    const tChart = log.time('ganttConfigure.chart');
    Chart.init(instance);
    tChart.end();

    if (!isMultiview) {
      const tBaselines = log.time('ganttConfigure.baselines');
      Baselines.init(instance);
      tBaselines.end();
    }

    const tGanttAdapter = log.time('ganttConfigure.ganttAdapter');
    GanttAdapter.init(instance); // GanttAdapter needs to sync gantt with vuex store
    tGanttAdapter.end();

    const tEvents = log.time('ganttConfigure.events');
    Events.init(instance); // Handling system gantt events and custom events
    tEvents.end();

    tConfigure.end();
  },

  configureInstanceForExport(instance, id, projectConfig) {
    // This method is lightweight copy of configureInstance method because we dont need all modules for export mode
    const t = log.time('ganttConfigure.export');
    Controllers.initForExport(instance);
    Config.init(id, instance, projectConfig);
    Extensions.init(instance);
    Grid.initForExport(instance, projectConfig);
    Chart.init(instance);
    if (!instance.config.multiview) {
      Baselines.init(instance);
    }
    GanttAdapter.initForExport(instance);
    Events.initForExport(instance);
    t.end();
  },

  configureInstanceForHistory(instance, id, projectConfig) {
    // This method is lightweight copy of configureInstance method because we dont need all modules for history mode
    const t = log.time('ganttConfigure.history');
    Controllers.initForExport(instance);
    Config.init(id, instance, projectConfig);
    Extensions.init(instance);
    Grid.initForExport(instance, projectConfig);
    Chart.init(instance);
    Events.initForExport(instance);
    t.end();
  },

  configureInstanceArchived(instance, id, projectConfig) {
    // This method is lightweight copy of configureInstance method because we dont need all modules for archived projects
    const t = log.time('ganttConfigure.archived');
    Controllers.initForArchived(instance);
    Config.init(id, instance, projectConfig);
    Extensions.init(instance);
    Grid.initForExport(instance, projectConfig);
    Chart.init(instance);
    Baselines.init(instance);
    GanttAdapter.initForArchived(instance);
    Events.initForArchived(instance);
    t.end();
  },

  resizeGantt() {
    const t = log.time('ganttResize.layout');
    WorkloadLayout.refreshHeight() || this.instance?.$layout?.resize?.();
    t.end();
  },

  renderInstance(instance, data, isWorkload = false) {
    ganttPreloader.show();
    setTimeout(() => {
      const tRenderTotal = log.time('ganttRender.total');

      const tInit = log.time('ganttRender.total.init');
      manualParentTaskBarLayersPatch(instance);
      instance.init('new_gantt_here');
      tInit.end();

      const tParse = log.time('ganttRender.total.parse');
      let tParseData;
      let tParseRender;
      const onBeforeParse = () => { tParseData = log.time('ganttRender.total.parse.data'); };
      const onParse = () => {
        tParseData.end();
        tParseRender = log.time('ganttRender.total.parse.render');
      };
      const onGanttRender = () => {
        tParseRender?.end();
        instance.detachEvent(parseListeners.before);
        instance.detachEvent(parseListeners.parse);
        instance.detachEvent(parseListeners.render);
      };
      const parseListeners = {
        before: instance.attachEvent('onBeforeParse', onBeforeParse),
        parse: instance.attachEvent('onParse', onParse),
        render: instance.attachEvent('onGanttRender', onGanttRender),
      };
      instance.parse(data);
      tParse.end();

      const tWorkload = log.time('ganttRender.total.workload');
      Workload.init(instance);
      tWorkload.end();

      ganttPreloader.hide();

      if (!isWorkload) {
        Events.initDomEvents(instance);
      }

      tRenderTotal.end();
    }, 0);
  },
};
